import { createRoute } from '@tanstack/react-router';

import { onboardingPageLoadable } from 'pages/onboarding-page';

import { AuthenticatedRoute } from '../authenticated-route';

export const OnboardingRoute = createRoute({
  getParentRoute: () => AuthenticatedRoute,
  path: '/onboarding',
  component: onboardingPageLoadable,
});
